<template>
  <ul class="card-additional-info container-lg">
    <li v-if="quizzesCount > 0">
      <img src="@/assets/images/ic_quiz_white.svg" />
      {{ quizzesCount }}
    </li>
    <li v-if="videosCount > 0">
      <img src="@/assets/images/ic_video_library_white.svg" />
      <span class="sr-only">
        {{ $t('comp.card.additional_info.label.videos_count') }}
      </span>
      {{ videosCount }}
    </li>
  </ul>
</template>

<script>
export default {
  name: 'card-additional-info',

  props: {
    quizzesCount: {
      type: Number,
      default: 0,
    },
    videosCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style lang="scss">
  @import '@/assets/styles/components/_typographies';
  @import '@/assets/styles/components/_breakpoints';

  .card-additional-info {
    margin: 0;
    padding: 0 0 12% 0;
    color: #ffffff;
    list-style: none;
    font-size: 20px;
    line-height: 1.65;

    @media (max-width: $tablet-breakpoint - 1) {
      font-size: 24px;
    }

    > li {
      display: inline-block;
      margin: 0 4px;

      &:first-child {
        margin-left: 0;
      }

      &:last-child {
        margin-right: 0;
      }

      > img {
        margin: 0 4px 0 4px;
      }
    }


    .sr-only {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0,0,0,0);
      border: 0;
    }
  }
</style>
